@let person = loadedPerson();
@if (!person) {
  <div>
    <h3>Loading Person</h3>
  </div>
}
@if (person) {
  <div>
    <div class="toolbar">
      <span>
        <button matButton="text" [disabled]="isBusy()" (click)="backToPersonSearch()">
          <span>
            <mat-icon class="size-16">keyboard_arrow_left</mat-icon>
            <label>Back To Search</label>
          </span>
        </button>
        @if (hasRole('IT') && !isNewPerson()) {
          <button matButton="text" [disabled]="isBusy()" (click)="manageRoles()">
            <span>
              <mat-icon class="size-16">person</mat-icon>
              <label>Roles</label>
            </span>
          </button>
        }
      </span>
      <span class="spacer"></span>
      <span>
        <button matButton="text" [disabled]="isBusy()" (click)="savePerson()">
          <span>
            <mat-icon class="size-16">done</mat-icon>
            <label>Save</label>
          </span>
        </button>
      </span>
    </div>
    @if (isBusy()) {
      <div class="busyIndicator">
        <mat-progress-spinner diameter="24" mode="indeterminate" strokeWidth="1"></mat-progress-spinner>
        <label class="busyLabel">Please Wait...</label>
      </div>
    }
  </div>
}
<div class="personPage">
  <table class="inputLayout">
    <tr>
      @if (errorMessage()) {
        <td colspan="6" class="alert alert-danger errors">
          {{ errorMessage() }}
        </td>
      }
    </tr>
    <tr>
      <td class="leftColumnLabel"><label for="firstNameInput">First Name</label></td>
      <td class="leftColumnInput">
        <input name="firstNameInput" class="inputField standardTextBox" maxlength="30" id="firstNameInput"
          [(ngModel)]="person.firstName" #firstName="ngModel"/>
      </td>
      <td class="middleColumnLabel"><label for="primaryOrgInput">Primary Org</label></td>
      @if (hasRole('IT')) {
        <td class="middleColumnInput">
          <select name="primaryOrgInput" id="primaryOrgInput" class="inputField" [(ngModel)]="person.primaryOrgUnitId"
            #primaryOrg="ngModel">
            <option value="">Please Select</option>
            @for (controllingOrg of controllingOrgs; track controllingOrg) {
              <option [value]="controllingOrg.code"
                >{{ controllingOrg.description }}
              </option>
            }
          </select>
        </td>
      }
      @if (!hasRole('IT')) {
        <td><label>{{ primaryOrgUnit.description }}</label></td>
      }
      <td class="rightColumnLabel"><label for="typeInput">Person Type</label></td>
      <td class="rightColumnInput">
        <select name="typeInput" id="typeInput" class="inputField" [(ngModel)]="person.typeCode" #type="ngModel">
          <option value="">Please Select</option>
          @for (personType of personTypes; track personType) {
            <option [value]="personType.code">{{ personType.description }}</option>
          }
        </select>
      </td>
    </tr>
    <tr>
      <td class="leftColumnLabel"><label for="lastNameInput">Last Name</label></td>
      <td class="leftColumnInput"><input name="lastNameInput" class="inputField standardTextBox" maxlength="30"
      id="lastNameInput" [(ngModel)]="person.lastName" #lastName="ngModel"/></td>
      <td class="middleColumnLabel"><label for="regionInput">Region</label></td>
      @if (hasRole('IT')) {
        <td class="middleColumnInput">
          <select name="regionInput" id="regionInput" class="inputField" [(ngModel)]="person.userCustomerOrgId"
            #region="ngModel">
            <option value="">Please Select</option>
            @for (region of regions; track region) {
              <option [value]="region.code">{{ region.description }}</option>
            }
          </select>
        </td>
      }
      @if (!hasRole('IT')) {
        <td><label>{{ userCustomerOrgUnit.description }}</label></td>
      }
      <td class="rightColumnLabel">Unit Sales Manager</td>
      <td class="rightColumnInput">
        <select name="unitSalesManagerInput" id="unitSalesManagerInput" class="inputField" [(ngModel)]="person.supervisorId" #unitSalesManager="ngModel"
          [disabled]="salesManagerInputDisabled()">
            <option value="">Please Select</option>
          @for (user of availableUnitSalesManagers; track user.code) {
            <option [value]="user.code">{{ user.description }}</option>
          }
        </select>
      </td>
    </tr>
    <tr>
      <td class="leftColumnLabel"><label for="titleInput">Title</label></td>
      <td class="leftColumnInput"><input name="titleInput" class="inputField standardTextBox" maxlength="30"
      id="titleInput" [(ngModel)]="person.title" #title="ngModel"/></td>
      <td class="middleColumnLabel"><label for="parentOfficeInput">Parent Office</label></td>
      @if (hasRole('IT')) {
        <td class="middleColumnInput">
          <select name="parentOfficeInput" id="parentOfficeInput" class="inputField" [(ngModel)]="person.userVendorOrgId"
            #parentOffice="ngModel">
            <option value="">Please Select</option>
            @for (repOffice of repOffices; track repOffice) {
              <option [value]="repOffice.code">{{ repOffice.description }}</option>
            }
          </select>
        </td>
      }
      @if (!hasRole('IT')) {
        <td><label>{{ userVendorOrgUnit.description }}</label></td>
      }
      <td class="rightColumnLabel">Parts Sales Manager</td>
      <td class="rightColumnInput">
        <select name="partsSalesManagerInput" id="partsSalesManagerInput" class="inputField" [(ngModel)]="person.partSalesManagerId" #partsSalesManager="ngModel"
            [disabled]="salesManagerInputDisabled()">
            <option value="">Please Select</option>
          @for (user of availablePartsSalesManagers; track user.code) {
            <option [value]="user.code">{{ user.description }}</option>
          }
        </select>
      </td>
    </tr>
    <tr>
      <td class="leftColumnLabel"><label for="phoneNumberInput">Phone Number</label></td>
      <td class="leftColumnInput"><input name="phoneNumberInput" class="inputField standardTextBox" maxlength="20"
        id="phoneNumberInput" [(ngModel)]="person.defaultPhoneNumber"
      #phoneNumber="ngModel"/></td>
      <td class="middleColumnLabel"><label for="userTypeInput">User Type</label></td>
      <td class="middleColumnInput">
        <select name="userTypeInput" id="userTypeInput" class="inputField" [(ngModel)]="person.userTypeCode"
          #userType="ngModel">
          <option value="">Please Select</option>
          @for (userType of userTypes; track userType) {
            <option [value]="userType.code">{{ userType.description }}</option>
          }
        </select>
      </td>
      <td class="rightColumnLabel"><label for="statusInput">Status</label></td>
      <td class="rightColumnInput">
        <select name="statusInput" id="statusInput" class="inputField" [(ngModel)]="person.statusCode "
          #statusInput="ngModel">
          <option value="">Please Select</option>
          @for (personStatusCode of personStatusCodes; track personStatusCode) {
            <option [value]="personStatusCode.code"
              >{{ personStatusCode.description }}
            </option>
          }
        </select>
      </td>
    </tr>
    <tr>
      <td class="leftColumnLabel"><label for="emailInput">E-Mail</label></td>
      <td class="leftColumnInput"><input name="emailInput" class="inputField standardTextBox" maxlength="250"
        id="emailInput" [(ngModel)]="person.emailAddress.emailAddress"
      #email="ngModel"/></td>
      <td class="middleColumnLabel"><label>Login</label></td>
      <td><label>{{ person.userLogin }}</label></td>
      <td class="rightColumnLabel"><label for="isActiveInput">Active</label></td>
      <td class="rightColumnInput"><input name="isActiveInput" type="checkbox" class="checkboxInput" id="isActiveInput"
      [(ngModel)]="person.active"/></td>
    </tr>
    <tr>
      <td class="leftColumnLabel"><label>Person ID</label></td>
      <td><label>{{ person.personId }}</label></td>
      <td class="middleColumnLabel"><label>Created</label></td>
      <td colspan="3"><label>{{ person.createUser }}
      - {{ person.createTimestamp | date: 'MM/dd/yyyy h:mm:ss a':'UTC' }}</label></td>
    </tr>
    <tr>
      <td></td>
      <td></td>
      <td class="middleColumnLabel"><label>Modified</label></td>
      <td colspan="3"><label>{{ person.updateUser }}
      - {{ person.updateTimestamp | date: 'MM/dd/yyyy h:mm:ss a':'UTC' }}</label></td>
    </tr>
  </table>
</div>
